export default __webpack_public_path__ + "static/media/YorkIE_Fuel-logo-grey.f6b73cb7.svg";